// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorProductReleases = (client) => ({
    /**
     * `POST /vendor/product-releases/incoming/:responseId/accept`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorProductReleasesIncomingAcceptCreate
     * @source packages/modules/b2c-core/src/api/vendor/product-releases/incoming/[responseId]/accept/route.ts
     */
    acceptIncoming: (responseId, body, query, headers) => client.fetch(buildPath("/vendor/product-releases/incoming/:responseId/accept", [responseId]), { method: "POST", body, query, headers }),
    /**
     * `GET /vendor/product-releases/incoming`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorProductReleasesIncomingList
     * @source packages/modules/b2c-core/src/api/vendor/product-releases/incoming/route.ts
     */
    listIncoming: (query, headers) => client.fetch("/vendor/product-releases/incoming", { method: "GET", query, headers }),
    /**
     * `POST /vendor/product-releases/incoming/:responseId/reject`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorProductReleasesIncomingRejectCreate
     * @source packages/modules/b2c-core/src/api/vendor/product-releases/incoming/[responseId]/reject/route.ts
     */
    rejectIncoming: (responseId, body, query, headers) => client.fetch(buildPath("/vendor/product-releases/incoming/:responseId/reject", [responseId]), { method: "POST", body, query, headers }),
    /**
     * `GET /vendor/product-releases/incoming/:responseId`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorProductReleasesIncomingRetrieve
     * @source packages/modules/b2c-core/src/api/vendor/product-releases/incoming/[responseId]/route.ts
     */
    retrieveIncoming: (responseId, query, headers) => client.fetch(buildPath("/vendor/product-releases/incoming/:responseId", [responseId]), { method: "GET", query, headers }),
});
//# sourceMappingURL=product-releases.js.map